'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useAuth } from '@repo/auth';
import type { DuplicateContainer } from '@repo/schema/page-data';
import { useMutation, useQuery, useQueryClient } from '@repo/tanstack/query';
import { useState } from 'react';
const DUPLICATE_PAGE_SLUG = 'loads-duplicate';

/**
 * The container the signed-in User last duplicated a load in, kept in their Page Data: the dialog
 * until they switch. A switch applies in this tab at once, whether or not the server saves it.
 */
export const useDuplicateContainer = () => {
  const $ = _c(6);
  const api = useApi();
  const {
    user
  } = useAuth();
  const queryClient = useQueryClient();
  const pageData = {
    path: {
      page: DUPLICATE_PAGE_SLUG,
      userId: user?.id ?? 0
    }
  };
  const {
    data
  } = useQuery({
    ...api.users.pageData.get.queryOptions(pageData),
    enabled: Boolean(user)
  });
  const {
    mutate
  } = useMutation(api.users.pageData.save.mutationOptions(pageData, {
    onSuccess: saved => queryClient.setQueriesData({
      queryKey: api.users.pageData.get.allScopesKey(pageData)
    }, saved)
  }));
  const [chosen, setChosen] = useState();
  const t0 = chosen ?? data?.value?.duplicateContainer ?? "dialog";
  let t1;
  if ($[0] !== mutate || $[1] !== user) {
    t1 = container => {
      setChosen(container);
      if (user) {
        mutate({
          duplicateContainer: container
        });
      }
    };
    $[0] = mutate;
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = {
      container: t0,
      rememberContainer: t1
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};